import en_uk_common from "./en_UK/common.json";
import en_uk_parts from "./en_UK/parts.json";

import en_us_common from "./en_US/common.json";
import en_us_parts from "./en_US/parts.json";

import cs_common from "./cs/common.json";
import cs_parts from "./cs/parts.json";

import da_common from "./da/common.json";
import da_parts from "./da/parts.json";

import de_common from "./de/common.json";
import de_parts from "./de/parts.json";

import es_common from "./es/common.json";
import es_parts from "./es/parts.json";

import fr_common from "./fr/common.json";
import fr_parts from "./fr/parts.json";

import it_common from "./it/common.json";
import it_parts from "./it/parts.json";

import nl_common from "./nl/common.json";
import nl_parts from "./nl/parts.json";

import no_common from "./no/common.json";
import no_parts from "./no/parts.json";

import pl_common from "./pl/common.json";
import pl_parts from "./pl/parts.json";

import pt_common from "./pt/common.json";
import pt_parts from "./pt/parts.json";

import sv_common from "./sv/common.json";
import sv_parts from "./sv/parts.json";

export default {
  "en_UK": { common: en_uk_common, parts: en_uk_parts },
  "en_US": { common: en_us_common, parts: en_us_parts },
  "cs": { common: cs_common, parts: cs_parts },
  "da": { common: da_common, parts: da_parts },
  "de": { common: de_common, parts: de_parts },
  "es": { common: es_common, parts: es_parts },
  "fr": { common: fr_common, parts: fr_parts },
  "it": { common: it_common, parts: it_parts },
  "nl": { common: nl_common, parts: nl_parts },
  "no": { common: no_common, parts: no_parts },
  "pl": { common: pl_common, parts: pl_parts },
  "pt": { common: pt_common, parts: pt_parts },
  "sv": { common: sv_common, parts: sv_parts },
};
